import { Flex, Typography } from "antd"
import cls from "classnames"

import Private from "../../../../../../Components/Private"
import Icon from "../../../../../../Icon"
import { formatCurrency } from "../../../../../../Utils/utils"
import { formatCount } from "../../../../components/Table/columns"
import { formatRate } from "../../../utils/formatNumber"

const { Text } = Typography

export const getColumns = ({ t, expandedKeys, isMobile, selectedMetric }) => {
  const allColumns = [
    {
      key: "billing_descriptor",
      title: t("Billing descriptor"),
      dataIndex: "billing_descriptor",
      render: (_, record) => {
        const row_type = record?.row_type
        const isExpandable = record?.months?.length > 0 && row_type !== "month"
        const isExpanded = expandedKeys.includes(record?.unique_id)

        // The month rows stay readable in Incognito mode — only the descriptor name itself is
        // hidden (CHA1-1357).
        if (row_type === "month") {
          return (
            <Text style={{ paddingLeft: "28px" }} strong>
              {record?.month_name}
            </Text>
          )
        }
        return (
          <Flex gap={8} align="center">
            {isExpandable && (
              <Icon
                type="chevron_down_small"
                className={cls("chevron_down", { expanded: isExpanded })}
              />
            )}
            <Text strong>{_ == null ? "—" : <Private>{_}</Private>}</Text>
          </Flex>
        )
      }
    },
    {
      key: "vamp_rate",
      title: t("VAMP ratio"),
      dataIndex: "vamp_rate",
      align: "right",
      render: (_, record) => {
        // Hidden in Incognito mode; the fraud / dispute / transaction counts below stay visible.
        return <Text strong>{getIsValidNumber(_) ? <Private>{formatRate(_)}</Private> : "—"}</Text>
      }
    },
    {
      key: "fraud_count",
      title: "Fraud count",
      dataIndex: "fraud_count",
      align: "right",
      render: (_, record) => {
        return <Text strong>{getIsValidNumber(_) ? formatCount(_) : "—"}</Text>
      }
    },
    {
      key: "dispute_count",
      title: "Dispute count",
      dataIndex: "dispute_count",
      align: "right",
      render: (_, record) => {
        return <Text strong>{getIsValidNumber(_) ? formatCount(_) : "—"}</Text>
      }
    },
    {
      key: "transaction_count",
      title: "Transaction count",
      dataIndex: "transaction_count",
      align: "right",
      render: (_, record) => {
        return <Text strong>{getIsValidNumber(_) ? formatCount(_) : "—"}</Text>
      }
    },
    {
      key: "transaction_volume",
      title: "Transaction volume",
      dataIndex: "transaction_volume",
      align: "right",
      render: (_, record) => {
        return (
          <Text strong>
            {getIsValidNumber(_) ? <Private>{formatCurrency(_, true)}</Private> : "—"}
          </Text>
        )
      }
    }
  ]

  if (isMobile) {
    return allColumns.filter(
      (col) => col.key === "billing_descriptor" || col.key === selectedMetric
    )
  }

  return allColumns
}

const getIsValidNumber = (value) => typeof value === "number" && !isNaN(value)
